<template>
  <modal name="LoginRegisterModal" class="login-register-modal" ref="modal">
    <!-- :class="{ 'login-register-header--white': signUpSet }" -->
    <!-- :closeModal="close" -->
    <modal-header class="login-register-header" name="LoginRegisterModal"></modal-header>
    <modal-main>
      <!-- <div v-show="signUp" class="modal-register-content">
        <div
          :class="
            signUpSet
              ? 'register-content__form-wrapper register-content__form-wrapper--opened'
              : 'register-content__form-wrapper'
          "
        >
          <register-form @close="close"></register-form>
        </div>
        <div
          :class="
            signUpSet
              ? 'register-content__info register-content__info--right'
              : 'register-content__info'
          "
        >
          <feedback-message v-if="type === 'FEEDBACK'"></feedback-message>
          <welcome-message v-else></welcome-message>
          <div class="signup-button-wrapper">
            <p class="small-text">Already have an account?</p>
            <button
              :style="{ border: 'none' }"
              class="form-wrapper__button--white"
              @click="toggleOption"
            >
              LOGIN
            </button>
          </div>
        </div>
      </div> -->
      <!-- <div v-show="!signUp" class="modal-login-content"> -->
      <div class="modal-login-content">
        <div :class="!signUpSet ? 'login-content__info login-content__info--left justify-content-center' : 'login-content__info justify-content-center'">
          <div>
            <img src="../../assets/images/dovemed-logo.png" />
          </div>
          <div>
            <feedback-message v-if="type === 'FEEDBACK'"></feedback-message>
            <return-message v-else></return-message>
          </div>
          <div>
            <bottom-message></bottom-message>
            <div class="registered-user">
              <div class="'user-image'">
                <img src="../../assets/images/user.png" />
              </div>
              <div class="user-text-group">
                <p class="username">Scott Lang</p>
                <p class="user-text">Registered User</p>
              </div>
            </div>
          </div>
          <!-- <div class="signup-button-wrapper">
            <p class="small-text">Don't have an account yet?</p>
            <button
              :style="{ border: 'none' }"
              class="form-wrapper__button--white"
              @click="toggleOption"
            >
              SIGNUP
            </button>
          </div> -->
        </div>
        <div :class="!signUpSet ? 'login-content__form-wrapper login-content__form-wrapper--opened' : 'login-content__form-wrapper'">
          <login-form @close="close" :signup="isSignUpSet"></login-form>
          <!-- <login-form @close="close" :signup="signUpSet"></login-form> -->
          <div class="go-back" @click="close">
            <font-awesome-icon class="icon" :icon="['fa', 'arrow-left']" />
            <span class="goback-text">Go back</span>
          </div>
        </div>
      </div>
    </modal-main>
  </modal>
</template>

<script>
import Modal from "./modal/modal"
import LoginForm from "./login-form"
import SocialLogin from "./social-login"
import RegisterForm from "./register-form"
import ReturnMessage from "./info/return-message"
import BottomMessage from "./info/bottom-message"
import WelcomeMessage from "./info/welcome-message"
import FeedbackMessage from "./info/feedback-message"
import PrivacyPolicy from "./info/privacy-policy"
import { modalSignals } from "./utils/utils"
import { responsiveHelper } from "./utils/responsive-helper"
import HorizontalLineWithTextInside from "./horizontal-line-with-text-inside"
import { mapGetters } from "vuex"

export default {
  name: "login-register-modal",

  components: {
    HorizontalLineWithTextInside,
    PrivacyPolicy,
    RegisterForm,
    SocialLogin,
    LoginForm,
    Modal,
    ReturnMessage,
    BottomMessage,
    WelcomeMessage,
    FeedbackMessage,
  },
  data: function () {
    return {
      type: null,
      signUp: null,
      submitted: false,
      signUpSet: false,
      isMobile: responsiveHelper.isMobileDevice(),
    }
  },
  computed: {
    ...mapGetters({ isSignUp: "SsoLogin/isSignUp", isSignUpSet: "SsoLogin/isSignUpSet", modalState: "SsoLogin/modalState" }),
  },

  watch: {
    isSignUp: function (old, newVal) {
      this.signUp = newVal
    },
    isSignUpSet: function (old, newVal) {
      this.signUpSet = newVal
    },
    // signUpSet: {
    //   handler(v) {
    //     console.log("signUpSet ->", v);
    //   },
    //   immediate: true,
    // },
  },
  mounted() {
    ;(this.signUp = this.isSignUp), (this.signUpSet = this.isSignUpSet)
  },
  methods: {
    toggleOption: function () {
      console.log(this.isSignUp, this.isSignUpSet, "asjdnaksjdb")
      // this.signUp = !this.signUp;
      this.$store.commit("SsoLogin/setSignUp", !this.isSignUp)
      this.signUp = this.isSignUp
      setTimeout(() => {
        // this.signUp ? (this.signUpSet = true) : (this.signUpSet = false);
        console.log("sign time out")
        this.isSignUp ? this.$store.commit("SsoLogin/setSignUpSet", true) : this.$store.commit("SsoLogin/setSignUpSet", false)

        this.signUpSet = this.isSignUpSet
      })
    },
    close: function () {
      this.isMobile && window.location.reload()
      this.$refs.modal.closeModal()
      this.$store.commit("SsoLogin/closeModal")
    },
    open: function () {
      this.$refs.modal.openModal()
    },
    goToHome() {
      $router.go(-1)
    },
  },
  mounted() {
    modalSignals.$on("toggle", (modal, type, open) => {
      this.type = type
      this.type === "SIGNUP" ? (this.signUp = true) : (this.signUp = false)
    })
  },
}
</script>

<style lang="scss">
.login-register-modal {
  font-family: "Lato", sans-serif;
  font-size: 16px;
  a {
    color: #227aa3;
  }
  .d-modal {
    width: 100vw;
    max-width: 100vw;
    max-height: 100%;
    border-radius: 0;
    @media screen and (max-height: 768px) {
      //height: 90vh;
    }
    @media screen and (max-width: 600px) {
      width: 100%;
      max-width: 100vw;
      height: 100%;
    }
    .d-modal-main {
      padding: 0;
      height: auto;
    }
  }

  .login-register-header {
    .d-modal-close {
      color: #0f74bd !important;

      @media screen and (max-width: 781px) {
        color: #333333 !important;
      }
    }
    .d-modal-header {
      background-color: transparent;
      margin: 0;
      padding: 0;
    }
    &--white {
      .d-modal-close {
        color: white !important;

        @media screen and (max-width: 781px) {
          color: #333333 !important;
        }
      }
      .d-modal-header {
        background-color: transparent;
        margin: 0;
        padding: 0;
      }
    }
  }
  .small-text {
    font-size: 12px;
    color: white;
    &--left {
      font-size: 12px;
      text-align: left;
    }
  }
  ::-webkit-scrollbar {
    display: none;
  }

  .modal-login-content {
    &--hidden {
      visibility: hidden;
    }
    @media screen and (max-height: 768px) {
      // height: 90vh;
    }
    .login-content {
      &__form-wrapper {
        width: 75%;
        overflow: scroll;
        // padding: 100px 200px;
        // padding: 4rem 2rem;
        // display: flex;
        align-items: center;
        justify-content: center;

        @media screen and (max-width: 900px) {
          width: 100%;
        }

        .go-back {
          cursor: pointer;
          position: absolute;
          top: 20px;
          right: 20px;
          border: none;
          border-radius: 6px;
          padding: 8px 16px;
          line-height: 20px;
          display: flex;
          align-items: center;
          background-color: rgb(226, 232, 240);
          color: rgb(71, 85, 110);
          @media screen and (max-width: 600px) {
            top: 0;
            margin-top: 48px;
          }
          .goback-text {
            font-size: 12px;
            font-weight: 700;
            margin: 0 10px;
          }
        }
      }
      &__info {
        display: flex;
      }
      &__info {
        padding: 4rem 2rem;
        width: 33%;
        // width: 25%;
        // min-height: 70vh;
        flex-direction: column;

        @media screen and (max-width: 768px) {
          width: 100%;
        }

        @media screen and (max-width: 900px) {
          margin-top: 40px;
        }
      }

      &__info {
        background-color: #2a71d4;
        color: white;
        justify-content: space-around;
        // transform: translateX(100%);
        // transition: 0.5s;

        @media screen and (max-width: 900px) {
          display: none;
        }

        &--left {
          transform: translateX(0);
          @media screen and (max-width: 900px) {
            display: none;
          }
          // display: none;//do for mobile pending
        }

        .registered-user {
          display: flex;
          align-items: center;
          margin-top: 25px;
          p {
            margin: 0;
          }
          .user-image {
            width: 40px;
            height: 40px;
          }
          .username {
            font-size: 16px;
            font-weight: 700;
            color: #ffffff;
            line-height: 0.5 !important;
          }
          .user-text-group {
            margin: 0 16px;
          }
          .user-text {
            font-size: 12px;
            font-weight: 400;
            color: #ffffff;
            margin-top: 10px;
          }
        }

        .form-wrapper {
          &__button--white {
            height: 45px;
            width: 350px;
            color: #0f74bd;
            background-color: white;
            border-radius: 35px;
          }
        }
      }

      &__form-wrapper {
        color: #999999;
        // transition: 0.5s;
        // transform: translateX(-100%);
        &--opened {
          // transform: translateX(0);

          @media screen and (max-width: 600px) {
            min-height: 90vh;
          }
        }
      }
    }
  }
  .modal-login-content,
  .modal-register-content {
    text-transform: none;
    display: flex;
    justify-content: center;
    // justify-content: space-between;
    height: 100vh;

    @media screen and (max-width: 900px) {
      height: auto;
      flex-direction: column;
    }

    .signup-button-wrapper {
      margin-bottom: 1.5rem;
    }
  }
  .modal-register-content {
    .register-content {
      &__form-wrapper,
      &__info {
        display: flex;
        flex-direction: column;
        align-items: center;
        text-align: center;
        padding: 2rem;
        width: 50%;

        @media screen and (max-width: 900px) {
          width: 100%;
          margin-top: 40px;
        }
      }

      &__form-wrapper {
        color: #999999;
        // transition: 0.5s;
        // transform: translateX(100%);
        // &--opened {
        //   transform: translateX(0);
        // }
      }

      &__info {
        background-color: #0075b4;
        color: white;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        // transition: 0.5s;
        // transform: translateX(-100%);
        &--right {
          // transform: translateX(0);
          @media screen and (max-width: 900px) {
            display: none;
          }
          // display: none;//do for mobile responsive
        }

        .form-wrapper {
          &__button--white {
            height: 45px;
            width: 350px;
            color: #0f74bd;
            background-color: white;
            border-radius: 35px;
          }
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/login/login-register-modal.vue